exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spinner-blocker{z-index:9990;height:100%;width:100%;background:#000;opacity:.2;left:0;top:0;position:fixed}.outer-container{z-index:9991;position:absolute;display:table;width:100%;height:100%}.inner-container{display:table-cell;vertical-align:middle;text-align:center}.centered-content{display:inline-block;padding:20px}", ""]);

